export const isEnterKey = (key: string): boolean => key === "Enter";
export const isEscapeKey = (key: string): boolean => key === "Escape";
